import { DateUtilities } from '@approot/utilities';
import { ColDef, ValueFormatterParams } from 'ag-grid-community';
import dayjs from 'dayjs';
import { GridRow } from '../provider-quote.model';

type SimpleParam = { value?: any; data?: any };

function dateFormatter(params: SimpleParam) {
  return params.value ? dayjs(params.value).format('D MMM YYYY') : '';
}

function defaultCellClass(params: SimpleParam) {
  return params.data.flash ? ['flash'] : [];
}

function requesterFormatter(params: ValueFormatterParams<GridRow>): string {
  if (params.data.rfqDetails?.is_wl) {
    return params.data.rfqDetails.email;
  }
  return params.data.requester || '';
}

export const defaultColDef: ColDef = {
  cellClass: defaultCellClass,
  sortable: true,
  enableRowGroup: false
};

export const columnDefs: ColDef[] = [
  {
    field: 'requestId',
    headerName: 'Request ID',
    filter: 'agTextColumnFilter',
    checkboxSelection: true
  },
  {
    field: 'action',
    headerName: 'Client Action',
    filter: 'agTextColumnFilter'
  },
  {
    field: 'quoteStatus',
    headerName: 'Quote Status',
    filter: 'agTextColumnFilter'
  },
  {
    field: 'requester',
    headerName: 'Requester',
    filter: 'agTextColumnFilter',
    valueFormatter: requesterFormatter
  },
  {
    field: 'owner',
    headerName: 'Owner',
    filter: 'agTextColumnFilter'
  },
  {
    field: 'cross',
    headerName: 'Currency Pair',
    filter: 'agTextColumnFilter'
  },
  {
    field: 'hedge',
    headerName: 'Hedge',
    filter: 'agTextColumnFilter'
  },
  {
    field: 'premiumCurrency',
    headerName: 'Premium Currency',
    filter: 'agTextColumnFilter'
  },
  {
    field: 'tradeDirection',
    headerName: 'Trade Direction',
    filter: 'agTextColumnFilter'
  },
  {
    field: 'premiumDate',
    headerName: 'Premium Date',
    comparator: DateUtilities.dateComparator,
    valueFormatter: dateFormatter,
    filter: 'agDateColumnFilter',
    filterParams: {
      // provide comparator function
      comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
        return DateUtilities.filterDateComparator(
          filterLocalDateAtMidnight,
          cellValue
        );
      }
    }
  }
];
